export const SSPM_MODAL_STEPS = {
  SELECT_AVAILABILITIES: 'select availabilities',
  CONFIRM_CHANGES: 'confirm changes',
  CONFIGURE_NEXT_AVAILABILITIES: 'configure next availabilities',
  CONFIRM_NEXT_AVAILABILITIES_CHANGES: 'confirm next availabilities change',
};
